<template>
    <div class="container-fluid my-3 py-3">
        <div class="row my-3">
            <div class="col-6">
                <div class="form-floating">
                    <input id="inputName" ref="name" type="text" name="name" class="form-control"  v-model="plantDashboardHeader.name" placeholder="name@example.com">
                    <label for="inputName" class="form-label" ><template v-if="plantDashboardHeader.is_group_name">{{ $t("group_name") }}</template><template v-else>{{ $t("component_name") }}</template></label>
                </div>
                
            </div>   
                         
        </div>
        <div class="row my-3">
            <div class="col-6">
                <div class="form-floating">
                    <input id="inputName" ref="name" type="text" name="name" class="form-control"  v-model="plantDashboardHeader.column" placeholder="name@example.com">
                    <label for="inputName" class="form-label" >{{ $t("column") }}</label>
                </div>
            </div>
            <div class="col-6">
                <div class="form-floating">
                    <input id="inputName" ref="name" type="text" name="name" class="form-control" v-model="plantDashboardHeader.position" placeholder="name@example.com">
                    <label for="inputName" class="form-label" >{{ $t("position") }}</label>
                </div>
            </div>
        </div>
        <div class="text-danger" v-if="errors.length">
            <p v-for="error in errors" v-bind:key="error">{{ error }}</p>
        </div>
        <button class="btn btn-success mb-0 ms-auto" @click="submitForm">{{ $t("save") }}</button>
    </div>
</template>

<script>
import { createToast } from '@/assets/js/myToast.js'
import axios from 'axios'
export default {
    name: 'AddPlantDashboardHeader',
    emits: ['closeModal'],
    props: {
        dashboard: {
            type: Object,
            required: true,
        }
    },
    data() {
        return {
            plantDashboardHeader: {
                name: '',
                position: '',
                is_group_name: false
            },

            errors: [],
        }
    },
    mounted(){
        console.log('entry mounted')
        this.focusInput()
        console.log('exit mounted')
    },
    methods: {
        focusInput() {
            console.log('entry focusInput')
            console.log(this.$refs.name)
            this.$refs.name.focus();
            console.log('exit focusInput')
        },
        submitForm() {
            this.plantDashboardHeader.plant_dashboard = this.dashboard.id
            this.plantDashboardHeader.created_by = this.$store.state.me.id
            this.plantDashboardHeader.modified_by = this.$store.state.me.id
            
            axios
                .post(`/api/v1/plantdashboards_headers/`, this.plantDashboardHeader)
                .then(response => {
        
                    createToast({text: this.$t("header added")
                        ,type: 'success'})
                    this.plantDashboardHeader.name = ''

                this.$emit('closeModal', 'add', response.data)
                })
                .catch(error => {
                    if (error.response) {
                        for (const property in error.response.data) {
                            this.errors.push(`${property}: ${error.response.data[property]}`)
                        }

                        console.log(JSON.stringify(error.response.data))
                    } else if (error.message) {
                        console.log(JSON.stringify(error.message))
                    } else {
                        console.log(JSON.stringify(error))
                    }
                })
        }
    },
    computed:{
    }
}
</script>